import { buyCoinPackage, getCoinPackageDetails } from "api/coinApi";
import React, { Fragment, useEffect, useState } from "react";
import coinIcon from "../../images/feed_images/coin-icon.svg"
import ThemeButton from "components/NewHome/ThemeButton";

function BuyCoinPage() {
    const [coinPackages, setCoinPackages] = useState<[string, { coins: number; price: number }][]>([]);

    const selectPackage = async (pkg:string) => {
        const response = await buyCoinPackage(pkg)
        if(response?.status === 'success'){
            window.location.href = response.checkout_url;
        }
    };

    const fetchCoinPackages = async () => {
        try {
            const result:any = await getCoinPackageDetails();
            if(result.status === 'success'){
                setCoinPackages(Object.entries(result.packages))
            }
        } catch (error) {
            console.error("Failed to fetch coin packages", error);
        }
    };
    
    useEffect(() => {
        fetchCoinPackages();
    }, []);

    return (
        <Fragment>
            <div className="container my-20">
                <h1 className="font-semibold text-center text-4xl">Coin package details</h1>

                <div className="flex flex-wrap mt-10 gap-4 justify-center">
                    {coinPackages.map(([key, { coins, price }]) => (
                        <div key={key} className="w-[250px] bg-[#E1B4B4] p-3 rounded-md">
                            <div className="">
                                <div className="relative h-24">
                                    <h3 className="pt-3 text-center text-gray-700 font-bold uppercase">{key}</h3>
                                    <img className="absolute left-[35%] bottom-[-30%] w-16 h-16" src={coinIcon} alt={coinIcon} />
                                </div>
                                <div className="bg-white p-3 rounded-md pt-10">
                                    <div className="mb-2">
                                        <p className="text-center">Coins</p>
                                        <div className="bg-[#FBE8A6] px-2 py-1 w-fit mx-auto rounded-sm font-semibold">{coins}</div>
                                    </div>
                                    <div>
                                        <p className="text-center">Price</p>
                                        <div className="bg-[#FBE8A6] p-2 w-fit mx-auto rounded-sm font-semibold">${price}</div>
                                    </div>
                                </div>
                                <div className="flex justify-center">
                                    <ThemeButton
                                        bgColor="bg-primaryColor"
                                        textColor="text-white"
                                        padding="p-2"
                                        size="text-base"
                                        rounded="rounded-md"
                                        className="w-24 font-medium mt-2"
                                        onClick={() => selectPackage(key)}
                                    >
                                        Buy coin
                                    </ThemeButton>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}

export default BuyCoinPage;